// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from 'reactstrap';
import {
  AvField,
  AvInput,
} from 'availity-reactstrap-validation';
import {
  InputDoubleButton,
  InputFile,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  getRegionSeasonUrl,
} from 'common.helpers/dist/browser';
import config from '../../../config';

// Types
import type {
  $ReducerState,
} from '../../../redux';

type $OptionalProps = {
  onChange?: () => unknown;
};

export type $OwnProps = $OptionalProps & $Translate & {
  item: $Model<'Championship'> | $ModelUpsertParams<'Championship'>;
  referenceData: Array<$Model<'Championship'>>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const ChampionshipFieldsView = function ({
  item,
  main,
  onChange,
  referenceData,
  t,
}: $Props) {
  const regionSeasonUrl: string = getRegionSeasonUrl({
    mainDomain: config.DOMAIN,
    regions: main.regions,
    RegionSeasonId: item.RegionSeasonId,
  });

  return (
    <Row>
      <Col sm={8}>
        <Row>
          <Col sm={4}>
            <InputDoubleButton
              className={'mb-3'}
              label={t('Visibility')}
              labelFalse={t('Hidden')}
              labelTrue={t('Visible')}
              name={'Public'}
              onChange={onChange}
              value={item.Public}
            />
          </Col>
          <Col
            sm={8}
            xs={12}
          >
            <AvField
              label={t('Title')}
              name={'Name'}
              onChange={onChange}
              required
              value={item.Name}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <InputFile
              fileDirUrl={`${config.CDN_URL}/images/max`}
              imageThumbDirUrl={`${config.CDN_URL}/images/min`}
              label={t('Logo')}
              labelChangeFile={t('Change file')}
              labelError={t('Error')}
              labelFile={t('File')}
              name={'Image'}
              onChange={onChange}
              onError={ErrorLog.exception}
              uploadUrl={`${config.CDN_URL}/v1.0/upload/image`}
              value={item.Image}
            />
          </Col>
          <Col
            sm={8}
            xs={12}
          >
            <Label>{t('Page address')}</Label>
            <InputGroup className={'mb-2'}>
              <InputGroupText>
                {regionSeasonUrl}
              </InputGroupText>
              <AvInput
                name={'Slug'}
                onChange={onChange}
                value={item.Slug}
              />
            </InputGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <AvField
              label={t('Reference championship')}
              name={'ReferenceId'}
              onChange={onChange}
              type={'select'}
              value={item.ReferenceId}
            >
              <option />
              {_.map(
                referenceData,
                (i) => (
                  <option
                    key={i.id}
                    value={i.id}
                  >
                    {i.Name}
                  </option>
                ),
              )}
            </AvField>
          </Col>
        </Row>
      </Col>
      <Col sm={4}>
        <Row>
          <Col>
            <AvField
              label={t('Organizer name')}
              name={'OrganizerName'}
              onChange={onChange}
              value={item.OrganizerName}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <AvField
              label={t('Organizer email')}
              name={'OrganizerEmail'}
              onChange={onChange}
              required
              type={'email'}
              value={item.OrganizerEmail}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

ChampionshipFieldsView.defaultProps = {
  onChange: undefined,
};

export default ChampionshipFieldsView;
